import { Components, Theme } from '@mui/material/styles';

const HEIGHT_SM = 34;
const HEIGHT_MD = 44;

export const MuiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      const isSmall = ownerState.size === 'small';
      const height = isSmall ? HEIGHT_SM : HEIGHT_MD;
      const paddingX = isSmall ? 8 : 10;

      // Typography follows the type scale: medium === body1, small === body2.
      const typeScale = isSmall
        ? theme.typography.body2
        : theme.typography.body1;

      return {
        ...typeScale,

        // Default border (idle)
        '&:not(.Mui-focused):not(.Mui-error):not(:hover) .MuiOutlinedInput-notchedOutline':
          {
            borderColor: theme.palette.customColors.inputBorder,
          },

        // Hover (not focused, not error) — gray
        '&:hover:not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline':
          {
            borderColor: theme.palette.grey[500],
          },

        // Focus — 2px brand accent (rti MP Dark / kc Kc Yellow)
        '&.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.customColors.inputFocus,
          borderWidth: '2px',
        },

        // Error — 2px, errorPale
        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.customColors.errorPale,
          borderWidth: '2px !important',
        },

        // Error hover/focus — 2px, solid Red Error
        '&.Mui-error:hover .MuiOutlinedInput-notchedOutline, &.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline':
          {
            borderColor: theme.palette.error.main,
            borderWidth: '2px',
          },

        // Non-multiline
        ...(ownerState.multiline !== true && {
          height,
          '& .MuiInputBase-input': {
            height,
            padding: `0 ${paddingX}px`,
            borderRadius: '4px',
          },
        }),

        // Multiline
        ...(ownerState.multiline === true && {
          padding: paddingX,
          minHeight: height,
          '& .MuiInputBase-input': {
            borderRadius: '4px',
          },
        }),

        // Disabled
        '&.Mui-disabled': {
          backgroundColor: theme.palette.grey[100],
          input: { WebkitTextFillColor: theme.palette.text.primary },
          '.MuiSelect-select': {
            WebkitTextFillColor: theme.palette.text.primary,
          },
          fieldset: { border: 'none' },
        },
      };
    },
  },
};
